import { render, staticRenderFns } from "./ZoneEditBasic.vue?vue&type=template&id=8a5a721c&scoped=true&"
import script from "./ZoneEditBasic.vue?vue&type=script&lang=js&"
export * from "./ZoneEditBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5a721c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VSpacer})
